import { useState, useEffect } from 'react';

export const useList = (collection, uid) => {

    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);

    useEffect(() => {
        setLoading(true);
        const unsubscribe = collection.onSnapshot(snapshot => {
            let list = [];
            snapshot.forEach(doc =>
                list.push({ ...doc.data(), uid: doc.id }),
            );
            setList(list);
            setLoading(false);

        }, error => {
            console.log("Error: ", error);
            setList(null);
            setLoading(false);
        });
        return () => unsubscribe();
    }, [uid])

    return { loading, list }

}